import { VuexModule, Module, getModule, Mutation, Action } from 'vuex-module-decorators';
import store from '@/store/store';
import { Address } from '../models';
import { getAddresses, addAddress, saveAddress, removeAddress } from '../api';

@Module({
  namespaced: true,
  name: 'addresses',
  dynamic: true,
  store,
})
class AddressesModule extends VuexModule {
  public addresses: Address[] = [];

  @Mutation
  public clean() {
    this.addresses = [];
  }

  @Mutation
  public setAddresses(addresses: Address[]) {
    addresses.sort((a, b) => a.id - b.id);
    this.addresses = addresses;
  }

  @Mutation
  public setAddress(address: Address) {
    const newAddresses: Address[] = [];
    this.addresses.forEach((addr) => {
      if (addr.id !== address.id) {
        newAddresses.push(addr);
      }
    });

    newAddresses.push(address);
    newAddresses.sort((a, b) => a.id - b.id);
    this.addresses = newAddresses;
  }

  @Mutation
  public rmAddress(id: number) {
    const newAddresses: Address[] = [];
    this.addresses.forEach((addr) => {
      if (addr.id !== id) {
        newAddresses.push(addr);
      }
    });

    newAddresses.sort((a, b) => a.id - b.id);
    this.addresses = newAddresses;
  }

  @Action({commit: 'setAddresses'})
  public async refreshAddresses(uid: number): Promise<Address[]> {
    return await getAddresses(uid);
  }

  @Action({commit: 'setAddress'})
  public async saveOrAddAddress(params: {uid: number, addr: Address}): Promise<Address> {
    if (params.addr.id == null || params.addr.id === 0) {
      return await addAddress(params.uid, params.addr);
    } else {
      return await saveAddress(params.uid, params.addr);
    }
  }

  @Action({commit: 'rmAddress'})
  public async removeAddress(params: {uid: number, addrId: number}): Promise<number> {
    return await removeAddress(params.uid, params.addrId);
  }
}

export default getModule(AddressesModule);
